module.exports = __webpack_public_path__ + "media/images/logo-white-1bbfcbec79d25114df2f0133ac59fb63.png";